import { commonInitMenu } from "../utils/commonInitMenu";
import {
  kBSRightClickCmds,
  kBSRightClickIcons,
  kBSRightClickOptions,
  kCanvasRightClickWidth
} from "../constants";
import { QIconDropDown } from "./QIconDropDown";

export class QBSRightClick extends QIconDropDown {
  constructor() {
    super();
  }

  InitMenu(baseCode, wsMgr, x, y) {
    if (wsMgr.GetDoc() == null) {
      var editIndex = kBSRightClickOptions.indexOf("Edit");
      if (editIndex > -1) {
        kBSRightClickOptions.splice(editIndex, 1);
        kBSRightClickCmds.splice(editIndex, 1);
        kBSRightClickIcons.splice(editIndex, 1);
      }
    }

    commonInitMenu(this, wsMgr, kBSRightClickOptions.length, x, y);
    this.InitIconDropDown(
      baseCode,
      wsMgr,
      kBSRightClickOptions,
      null,
      kBSRightClickCmds,
      kBSRightClickIcons,
      true,
      kCanvasRightClickWidth
    );
  }
}
